// jQuery plugins
import $ from './globals/jquery';
import 'jquery-trend'; // eslint-disable-line
import 'jquery-revealer'; // eslint-disable-line

// Global imports
import './globals/flickity-ios-fix';
import scriptjs from 'scriptjs';

// Responsive Images
import rimg from 'rimg-shopify'; // eslint-disable-line

// Template imports
import Account from './templates/Account';
import Contact from './templates/Contact';
import Page from './templates/Page';
import GiftCard from './templates/GiftCard';

// Section imports
import Sections from './Sections';
import StaticAnnouncement from './sections/StaticAnnouncement';
import StaticSectionHeader from './sections/StaticSectionHeader';
import StaticSectionFooter from './sections/StaticSectionFooter';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticPassword from './sections/StaticPassword';
import StaticProduct from './sections/StaticProduct';
import StaticSearch from './sections/StaticSearch';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicHighlightsBanners from './sections/DynamicHighlightsBanners';
import StaticSlideshow from './sections/StaticSlideshow';
import DynamicPromoBlocks from './sections/DynamicPromoBlocks';
import DynamicMenuList from './sections/DynamicMenuList';
import DynamicTwitterFeed from './sections/DynamicTwitterFeed';
import DynamicInstagramFeed from './sections/DynamicInstagramFeed';
import DynamicCollectionList from './sections/DynamicCollectionList';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicSearch from './sections/DynamicSearch';
import DynamicRichText from './sections/DynamicRichText';
import DynamicVideo from './sections/DynamicVideo';
import DynamicNewsletter from './sections/DynamicNewsletter';
import DynamicMap from './sections/DynamicMap';

import polyfillUrls from './checkPolyfills';

const initEmpire = () => {
  rimg.init('[data-rimg="lazy"]', { round: 1 });

  const sections = new Sections();
  sections.register('static-header', section => new StaticSectionHeader(section));
  sections.register('static-announcement', section => new StaticAnnouncement(section));
  sections.register('static-footer', section => new StaticSectionFooter(section));
  sections.register('static-article', section => new StaticArticle(section));
  sections.register('static-blog', section => new StaticBlog(section));
  sections.register('static-cart', section => new StaticCart(section));
  sections.register('static-collection', section => new StaticCollection(section));
  sections.register('static-password', section => new StaticPassword(section));
  sections.register('static-product', section => new StaticProduct(section));
  sections.register('static-search', section => new StaticSearch(section));
  sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
  sections.register('dynamic-collection-list', section => new DynamicCollectionList(section));
  sections.register('dynamic-highlights-banners', section => new DynamicHighlightsBanners(section));
  sections.register('static-slideshow', section => new StaticSlideshow(section));
  sections.register('dynamic-promo-mosaic', section => new DynamicPromoBlocks(section));
  sections.register('dynamic-promo-grid', section => new DynamicPromoBlocks(section));
  sections.register('dynamic-menu-list', section => new DynamicMenuList(section));
  sections.register('dynamic-twitter-feed', section => new DynamicTwitterFeed(section));
  sections.register('dynamic-instagram-feed', section => new DynamicInstagramFeed(section));
  sections.register('dynamic-featured-collection', section => new DynamicFeaturedCollection(section));
  sections.register('dynamic-featured-product', section => new StaticProduct(section));
  sections.register('dynamic-rich-text', section => new DynamicRichText(section));
  sections.register('dynamic-search', section => new DynamicSearch(section));
  sections.register('dynamic-video', section => new DynamicVideo(section));
  sections.register('dynamic-newsletter', section => new DynamicNewsletter(section));
  sections.register('dynamic-map', section => new DynamicMap(section));

  if ($('body.giftcard').length) {
    new GiftCard();
  }

  new Account();
  new Contact();
  new Page();

  // This file gets reloaded for every page navigation, so when turbolinks is enabled
  // we need to explicitly unload all JS before navigating to another page to ensure
  // a clean JS slate for the next page.
  if (document.querySelector('[data-turbolinks-enabled]')) {
    const unloadAll = () => {
      document.removeEventListener('turbolinks:click', unloadAll);
      sections.unbind();
    };
    document.addEventListener('turbolinks:click', unloadAll);
  }

  // Flickity hot fix until Webkit fixes this bug: https://bugs.webkit.org/show_bug.cgi?id=184250#c31
  $(document).on('dragStart.flickity', '.flickity-enabled', () => {
    document.ontouchmove = (e) => {
        e.preventDefault();
      }
    });

  $(document).on('dragEnd.flickity', '.flickity-enabled', () => {
    document.ontouchmove = () => {
      return true;
    }
  });
};

if (polyfillUrls.length) {
  scriptjs(polyfillUrls, initEmpire);
} else {
  initEmpire();
}
